import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import CustomButton from 'src/core/ui/CustomButton';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { useProductLinesTable } from './useProductLinesTable';

export const ProductLinesTablePage = () => {
    const [columns, tableSettings] = useProductLinesTable();
    return (
        <>
            <PageHeader title="Product Lines" subTitle="View and edit product lines" components={[
                ...generateTablePageButtons(tableSettings),
                { component: <CustomButton title="New Product Line" icon={<AddTwoToneIcon />} actionUrl="/products/product-lines/create" /> },
            ]} />
            <ContentCardsContainer>
                <ContentCard cardId="ProductLines" cardTypes={[CardType.noHeader]} contentPadding={0}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} />
                </ContentCard>
            </ContentCardsContainer>
            <Footer />
        </>
    );
};

export default ProductLinesTablePage;
